import {ReleaseNote} from "~/queries";

const STORAGE_KEY = "last-showed-release";


export function getLastShowedReleaseVersion() {
    return localStorage.getItem(STORAGE_KEY);
}


export function markReleaseNoteShowed(releaseNote: ReleaseNote) {
    const lastShowedVersion = getLastShowedReleaseVersion();
    if (lastShowedVersion != null && lastShowedVersion == releaseNote.version) {
        return
    }
    localStorage.setItem(STORAGE_KEY, releaseNote.version);
}


export function needShowReleaseNotes(releaseNote: ReleaseNote) {
    const lastShowedVersion = getLastShowedReleaseVersion();
    if (lastShowedVersion == null) {
        markReleaseNoteShowed(releaseNote);
        return false;
    }

    const normalize = (version: string) => version.split(".").slice(0, 3).join(".");

    return normalize(lastShowedVersion) != normalize(releaseNote.version);
}